import $ from 'jquery'
import load_map from '@activity/js/apps'

function lazy_load(elem) {

  /* LazyLoaderFallback conitnue to run lazy_load on elements that
     have not got lazy class anymore */
  if(!elem.hasClass('lazy')) {
    return
  }

  if(elem.data('lazy-bg')) {
    elem.css('background-image', elem.data('lazy-bg'))
  }
  else if(elem.data('lazy-src')) {
    elem.attr('src', elem.data('lazy-src'))
  }
  else if(elem.is('video')) {
    elem.find('source').each(function(){
      $(this).attr('src', $(this).data('lazy-src'))
    })
    elem[0].load()
  }
  else if(elem.hasClass('lazy-map')) {
    load_map()
  }
  elem.removeClass("lazy");
}

class LazyLoaderObserver {

  constructor() {
    this.$lazyloadImages = $(".lazy");
    let options = {
      root: null,
      rootMargin: '100px',
      threshold: 0
    }
    this.elementObserver = new IntersectionObserver(
      (entries, observer) => this.observe(entries, observer), options)
    this.init()
  }

  init() {
    this.$lazyloadImages.each((i, elem) => {
      this.elementObserver.observe(elem);
    });
  }

  observe(entries, observer) {
      entries.forEach(entry => {
      if (entry.isIntersecting) {
        let elem = entry.target;
        lazy_load($(elem))
        this.elementObserver.unobserve(elem);
      }
    });
  }

}

class LazyLoaderFallback {

  constructor() {
    this.$lazyloadImages = $(".lazy");
    this.lazyloadThrottleTimeout;
    this.init()
  }

  init() {
    $(document).on("scroll", () => this.lazyload());
    $(window).on("resize", () => this.lazyload());
    $(window).on("orientationChange", () => this.lazyload());
  }

  lazyload () {
    if(this.lazyloadThrottleTimeout) {
      clearTimeout(this.lazyloadThrottleTimeout);
    }    

    this.lazyloadThrottleTimeout = setTimeout(() => {
      var scrollTop = window.pageYOffset;
      this.$lazyloadImages.each(function(i, img) {
          if(img.offsetTop < (window.innerHeight + scrollTop)) {
            lazy_load($(img))
          }
      });
      if(this.$lazyloadImages.length == 0) { 
        $(document).off("scroll", this.lazyload);
        $(window).off("resize", this.lazyload);
        $(window).off("orientationChange", this.lazyload);
      }
    }, 20);
  }

}

export default class LazyLoader {

  constructor() {
    if ("IntersectionObserver" in window) {
      new LazyLoaderObserver()
    } else {
      new LazyLoaderFallback()
    }
  }


}



// WEBPACK FOOTER //
// ./utils/static/utils/js/lazy-loader.js